/**
 * GridIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const GridIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M19 2.25A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25zM3.75 15.75V19c0 .69.56 1.25 1.25 1.25h3.25v-4.5zm6 0v4.5h4.5v-4.5zm6 0v4.5H19c.69 0 1.25-.56 1.25-1.25v-3.25zm-12-1.5h4.5v-4.5h-4.5zm6 0h4.5v-4.5h-4.5zm6 0h4.5v-4.5h-4.5zM5 3.75c-.69 0-1.25.56-1.25 1.25v3.25h4.5v-4.5zm4.75 4.5h4.5v-4.5h-4.5zm6 0h4.5V5c0-.69-.56-1.25-1.25-1.25h-3.25z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const GridIcon = makeIcon('GridIcon', GridIconSvg)
